export const formName = 'gtForm';

export const fieldConfig = {
    type: {
        fieldName: 'type',
        label: 'Great Telepresence Type',
    },

    description: {
        fieldName: 'description',
        label: 'Description',
        type: 'text',
        required: false,
    },

    fileUpload: {
        fieldName: 'fileUpload',
        label: '',
        type: 'file',
    },

    division: {
        fieldName: 'division',
        label: 'Division',
    },

    desk: {
        fieldName: 'desk',
        label: 'Desk #',
    },

    date: {
        fieldName: 'date',
        label: 'Date',
        type: 'date',
    },

    shift: {
        fieldName: 'shift',
        label: 'Shift',
    },

    location: {
        fieldName: 'location',
        label: 'Customer',
    },

    companyRelation: {
        fieldName: 'companyRelation',
        label: 'Company Relation',
    },

    note: {
        fieldName: 'note',
        label: 'Note',
        type: 'text',
        required: false,
    },
    assistance: {
        fieldName: 'assistance',
        label: 'Assistance',
        type: '',
        required: false,
    },

    enforcement: {
        fieldName: 'enforcement',
        label: 'Enforcement',
        type: '',
        required: false,
    },
    agent: {
        fieldName: 'agent',
        label: 'Agent',
    },
    teamLeader: {
        fieldName: 'teamLeader',
        label: 'Team leader',
    },
    shiftManager: {
        fieldName: 'shiftManager',
        label: 'Shift manager on duty',
        required: false,
    },
};
